// eslint-disable-next-line no-shadow
export enum Path {
  Home = '/',
  Login = '/login',
  Register = '/register',
  RegisterSender = '/register/sender',
  RegisterReceiver = '/register/receiver',
  RegisterRemittance = '/register/remittance',
  RegisterWhiteLabel = '/register/white-label',
  ResetPassword = '/reset-password',
  ChangePassword = '/change-password',
  SendMoney = '/send',
  VerifyEmail = '/verify-successful',
  /**
   * Dashboard is an alias for the SendMoney page. This can be changed if we have a distinct Dashboard page later on.
   * If you change this in the future, please add an entry to `routes` & update `Dashboard` in `@src/screens.tsx`
   */
  Onboarding = '/onboarding',
  OnboardingRemittance = '/remittance-onboarding',
  OnboardingWhiteLabel = '/white-label-onboarding',
  PaymentSuccess = '/payment-success',
  ModulrCallback = '/modulr-callback',
  VolumeCallback = '/volume-callback',
  StripeCallback = '/stripe-callback',
  PaymentCallback = '/payment-callback',

  /**
   * Payment Link
   */

  PaymentLinkUsage = '/payment-link',

  /**
   * Receiver routes
   */
  ReceiverDashboard = '/receiver/dashboard',
  ReceiverTransactions = '/receiver/transactions',
  ReceiverSettlements = '/receiver/settlements',
  ReceiverCustomers = '/receiver/customers',
  ReceiverPaymentLinks = '/receiver/payment-links',
  ReceiverSettings = '/receiver/settings',
  ReceiverBusinessPref = '/receiver/settings/business-preference',
  ReceiverProfile = '/receiver/settings/profile',
  ReceiverTeams = '/receiver/settings/teams',
  ReceiverPermissions = '/receiver/settings/permissions',
  ReceiverSettlementAccount = '/receiver/settings/settlement',
  ReceiverPermissionsDetails = '/receiver/details',
  ReceiverSettleDetails = '/receiver/settledetails',
  newrole = 'newrole',

  /**
   * Sender routes
   */
  SenderDashboard = '/sender/dashboard',
  SenderSetupGuide = '/sender/setup-guide',
  SenderApiKeysWebhooks = '/sender/api-keys-and-webhooks',
  SenderTransactions = '/sender/transactions',
  SenderPaymentLinks = '/sender/payment-links',
  SenderInitiateTransfer = '/sender/initiate-transfer',
  SenderSettings = '/sender/settings',
  SenderBusinessPref = '/sender/settings/business-preference',
  SenderProfile = '/sender/settings/profile',
  SenderTeams = '/sender/settings/teams',
  SenderPermissions = '/sender/settings/permissions',
  SenderSettlement = '/sender/settings/settlement',
  SenderPermissionsDetails = 'sender/details',
  SenderSettleDetails = 'sender/settledetails',
  SenderNewrole = 'newrole',

  /**
   * White Label routes
   */
  WhiteLabelSetup = '/white-label/setup',
  WhiteLabelCustomiseProduct = '/white-label/customise-product',
  WhiteLabelDashboard = '/white-label/dashboard',
  WhiteLabelRatesAndFees = '/white-label/rates-and-fees',
  WhiteLabelSenders = '/white-label/senders',
  WhiteLabelReceivers = '/white-label/receivers',
  WhiteLabelTransactions = '/white-label/transactions',
  WhiteLabelSettings = '/white-label/settings',
  WhiteLabelSettingsProfile = '/white-label/settings/profile'
}
